module.exports = __webpack_public_path__ + "/img/SOD-Custom-Footprint-UJY67G.svg";